import Base from './BaseLayoutProviderContainer'

export default Base